import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, Input } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { BaseButton } from 'views/UIWidgets';

const useStyles = makeStyles(theme => ({
	root: {
		borderRadius: '4px',
		alignItems: 'center',
		padding: theme.spacing(1),
		display: 'flex',
		flexBasis: 420,
	},
	icon: {
		marginRight: theme.spacing(1),
		color: theme.palette.text.secondary,
	},
	input: {
		flexGrow: 1,
		fontSize: '14px',
		lineHeight: '16px',
		letterSpacing: '-0.05px',
	},
}));

const SearchInput = props => {
	const { className, onSearch, style, ...rest } = props;

	const [query, setQuery] = useState('');

	const classes = useStyles();

	const onChange = e => {
		setQuery(e.target.value);
	};

	const onClick = () => {
		onSearch(query);
	};

	return (
		<Paper {...rest} className={clsx(classes.root, className)} style={style}>
			<SearchIcon className={classes.icon} onClick={onClick} />
			<Input
				{...rest}
				className={classes.input}
				disableUnderline
				value={query}
				onChange={onChange}
			/>
			<BaseButton title='搜索' onClick={onClick} />
			<BaseButton
				style={{ marginLeft: 4 }}
				mainColor='secondary'
				title='重置'
				onClick={() => {
					onSearch('');
					setQuery('');
				}}
			/>
		</Paper>
	);
};

SearchInput.propTypes = {
	className: PropTypes.string,
	onSearch: PropTypes.func.isRequired,
	style: PropTypes.object,
};

export default SearchInput;
